import './AppFormLayout.less'

import { Icon } from 'antd'
import { AppComponent } from 'components/AppComponent/AppComponent'
import React from 'react'
import { hasPermission } from 'services/permission'

import { ActionFunction } from './AppFormMenu'
import { AppEvent } from 'components/AppEvent'
import AppAction from 'components/AppAction/AppAction'

export interface AppParam {
	name?: string
	type?: string
	value?: string
}
export interface AppEvent {
	name?: string // click
	type?: string // page ,action
	pageUrl?: string // self blank
	component?: string // dialog panel
	width?: number
	height?: number
	openType?: string // self,dialog,panel,blank
	paramlist?: AppParam[]
	actionType?: string
	functionName?: string
}
export interface AppFormActionProps extends ActionFunction {
	width?: number
	actionCode?: string
	type?: string
	action?: () => void
	icon?: string
	title?: string
	className?: any
	appEventList?: AppEvent[]
}

class AppFormAction extends React.Component<AppFormActionProps, {}> {
	doPage = (appEvent: AppEvent) => {
		// self,dialog,panel,blank
		// 参数处理，目前仅支持固定参数
		let params: string[] = (appEvent.paramlist && appEvent.paramlist.map(p => `${p.name}=${p.value}`)) || []

		switch (appEvent.openType) {
			case 'self': {
				// 二级页面
				const url = appEvent.pageUrl + '?' + params.join('&')
				AppEvent.redirect(url)
				// return getCurrHistory().push(url)
				// this.props.history.push(url);
			}
			case 'dialog':
				// return AppDialog.open(<AppComponent component={appEvent.component} paramlist={appEvent.paramlist} />, {
				//   ...appEvent,
				// })
				return AppEvent.openDialog(
					<AppComponent component={appEvent.component} paramlist={appEvent.paramlist} />,
					{
						...appEvent,
					}
				)
			case 'panel':
				const { openType, component, pageUrl, ...rest } = appEvent
				// return Drawer.show(
				//   <AppComponent component={appEvent.component} paramlist={appEvent.paramlist} />,
				//   { ...rest },
				//   {}
				// )
				return AppEvent.openDrawer(
					<AppComponent component={appEvent.component} paramlist={appEvent.paramlist} />,
					{ ...rest }
				)
			case 'blank': {
				const url = appEvent.pageUrl + '?' + params.join('&')
				// return (window.open('about:blank').location.href = url)
				return AppEvent.open(url)
			}
			default:
				return null
		}
	}
	doPageAction = (appEvent: AppEvent) => {
		// 1
		if (appEvent.actionType) {
			switch (appEvent.actionType) {
				// Gird
				case 'addRow': // 新增行
					this.props.addRow && this.props.addRow()
					break
				case 'delRow': // 删除行
					this.props.delRow && this.props.delRow()
					break
				case 'Print': // 打印
					this.props.Print && this.props.Print()
					break
				case 'export': // 导出
					this.props.export && this.props.export()
					break
				// Form
				case 'saveForm': // 保存
					this.props.saveForm && this.props.saveForm()
					break
				case 'saveFormClose': // 保存&关闭
					this.props.saveFormClose && this.props.saveFormClose()
					break
				case 'saveFormAdd': // 保存&新增
					this.props.saveFormAdd && this.props.saveFormAdd()
					break
				case 'saveFormReturn': // 保存&返回
					this.props.saveFormReturn && this.props.saveFormReturn()
					break
				case 'FormReturn': // 返回
					this.props.FormReturn && this.props.FormReturn()
					break
				case 'FormForward': // 下一步
					this.props.FormForward && this.props.FormForward()
					break
				case 'FormBack': // 上一步
					this.props.FormBack && this.props.FormBack()
				case 'customer':
					this.props.customer && this.props.customer(appEvent.functionName)
					break
			}
		}
	}

	doAction = () => {
		let { appEventList } = this.props
		let appEvent = appEventList && appEventList.find(e => e.name === 'click')
		if (appEvent) {
			switch (appEvent.type) {
				case 'page':
					this.doPage(appEvent)
					break
				case 'action':
					this.doPageAction(appEvent)
					break
			}
		}
		this.props.action && this.props.action()
	}

	render() {
		return <AppAction action={this.doAction} {...this.props}></AppAction>
	}
}
export default AppFormAction



// WEBPACK FOOTER //
// ./src/components/AppFormLayout/AppFormAction.tsx